import logoBlack from './logo-black.png';
import logoWhite from './logo-white.png';

export { logoBlack, logoWhite };
